import { Option, Select } from '@/shared/ui/Selector'

export enum SortType {
	PopularityToLow = `popular`,
	PriceLowToHigh = `price|asc`,
	PriceHighToLow = `price|desc`
}

export enum SaleSortType {
	PopularityToLow = `popular&direction=desc`,
	PriceLowToHigh = `price&direction=asc`,
	PriceHighToLow = `price&direction=desc`
}

type SortTypeSelectorProps = {
	onChange: (newSortType: SortType | SaleSortType) => void
	defaultValue?: SortType | SaleSortType
	value?: SortType | SaleSortType
	isSaleSort?: boolean
	className?: string
}

export const SortTypeSelector = ({
	onChange,
	defaultValue,
	value,
	isSaleSort,
	className
}: SortTypeSelectorProps): JSX.Element => {
	const defaultSortType = defaultValue || (isSaleSort ? SaleSortType.PopularityToLow : SortType.PopularityToLow)
	const currentValue = value || defaultSortType

	const options: Option[] = [
		{
			value: isSaleSort ? SaleSortType.PopularityToLow : SortType.PopularityToLow,
			label: `По популярности`
		},
		{
			value: isSaleSort ? SaleSortType.PriceLowToHigh : SortType.PriceLowToHigh,
			label: `Цена по возрастанию`
		},
		{
			value: isSaleSort ? SaleSortType.PriceHighToLow : SortType.PriceHighToLow,
			label: `Цена по убыванию`
		}
	]

	const onSortTypeChange = (value?: string) => {
		if (value) {
			onChange(value as SortType | SaleSortType)
		}
	}

	return (
		<div className={className}>
			<Select
				mobileModal
				mobileTitle="Сортировка товара"
				mobileCloseControl="cross"
				value={currentValue}
				options={options}
				onChange={onSortTypeChange}
			/>
		</div>
	)
}
